import React from 'react';
import PageMenu from './PageMenu';

function MenuFind(props) {
  return (
    <PageMenu
      {...props}
      title="Gallery Menu"
      items={[
        {
          name: 'image-gallery',
          title: 'Image Gallery',
          activeExact: false,
        },
        // {
        //   name: 'custom-gallery',
        //   title: 'Custom Gallery',
        //   activeExact: false,
        // },
        {
          name: 'media-and-press',
          title: 'Media & Press',
          keepParams: true,
          activeExact: false,
        },
      ]}
    />
  );
}

export default MenuFind;



// WEBPACK FOOTER //
// ./src/components/MenuGallery.js